const isEmpty = (object) => {
  return Object.keys(object).length == 0 || object.length == 0 || object === "";
};

export {
  isEmpty
}
